import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { DialogConfig, DialogService } from "@obg/mat.ui.core";
import { LimitsReminderAction } from "@obg/ngx.core";
import { CacheFactory, CacheStore, DeviceConfigService, StorageMode } from "@obg/ngx.global";

import { LimitsReminderDialogContainer } from "../dialog/limits-reminder-dialog.container";
import { LIMITS_REMINDER_LAST_GAME_ID_CACHE_KEY, LIMITS_REMINDER_MODAL_ID } from "../module.const";

@Injectable({
	providedIn: "root",
})
export class LimitsReminderService {
	private cache: CacheStore;

	constructor(
		private deviceConfigService: DeviceConfigService,
		private dialogService: DialogService,
		private cacheFactory: CacheFactory,
		private store: Store,
		private matDialog: MatDialog
	) {
		this.cache = this.cacheFactory.get(LIMITS_REMINDER_LAST_GAME_ID_CACHE_KEY, {
			storageMode: StorageMode.LocalStorage,
		});
	}

	updateGameIdFromCache() {
		this.cache.getItem<string>(LIMITS_REMINDER_LAST_GAME_ID_CACHE_KEY).then((gameId) => {
			if (!gameId) {
				return;
			}
			this.store.dispatch(LimitsReminderAction.updateLastGameId(gameId));
		});
	}

	saveLastGameIdIntoCache(gameId: string) {
		this.cache.getItem<string>(LIMITS_REMINDER_LAST_GAME_ID_CACHE_KEY).then((gameIdInCache) => {
			if (gameIdInCache === gameId) {
				return;
			}
			this.cache.setItem<string>(LIMITS_REMINDER_LAST_GAME_ID_CACHE_KEY, gameId);
		});
	}

	showLimitsReminder() {
		const existingLimitsReminderDialog = this.matDialog.getDialogById(LIMITS_REMINDER_MODAL_ID);
		if (existingLimitsReminderDialog) {
			return;
		}

		const dialogConfig: Partial<DialogConfig> = {
			id: LIMITS_REMINDER_MODAL_ID,
			width: "860px",
			closeOnNavigation: false,
			disableClose: true,
		};

		if (!this.deviceConfigService.isDesktop()) {
			dialogConfig.width = "100%";
			dialogConfig.height = "100vh";
		}

		this.dialogService.openComponent(LimitsReminderDialogContainer, dialogConfig);
	}
}
